import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { setupNotifications } from '../../../containers/authentication/utils/setup-notifications'
import { Settings } from 'luxon'
import { authorization } from '../../../containers/authentication/constants'
import { useLanguageStore } from '../../../zustand/language/use-language-store'
import { useAuthStore } from '../../../zustand/authentication/use-auth-store'
import { authMutationKeys } from '../constants'

export const useLoginMutation = () => {
  const { setPasswordPolicy, loginSuccessful, setShow2FA } = useAuthStore()

  const { locale, localeChanged } = useLanguageStore()

  const handleLoginCredentials = async (email, password) => {
    const config = {
      method: 'post',
      headers: {
        Authorization: authorization
      },
      data: {
        username: email,
        password,
        grant_type: 'password'
      }
    }

    const { data } = await api('/api/oauth/token', config)

    return data
  }

  const handleChangeLocale = async (token, locale) => {
    const config = {
      method: 'patch',
      headers: {
        Authorization: `${token.token_type} ${token.access_token}`
      },
      data: {
        settings: {
          language: locale
        }
      }
    }

    const { data } = await api('/api/me', config)

    return data
  }

  const handleTwoFactor = async (email) => {
    const config = {
      method: 'get',
      params: {
        email
      },
      headers: null
    }

    const { data } = await api('/api/twoFactor', config)

    return data
  }

  const handleMfa = async (email) => {
    const config = {
      method: 'get',
      params: {
        email
      }
    }

    const { data } = await api('/api/mfa-api/sms', config)

    return data
  }

  const handleMutation = async ({ email, password }) => {
    const twoFaStatus = await handleTwoFactor(email)

    if (twoFaStatus) {
      setPasswordPolicy(twoFaStatus)
      if (twoFaStatus.sms || twoFaStatus.otp) {
        if (twoFaStatus.sms) {
          await handleMfa(email)
        }
        setShow2FA(twoFaStatus)
      } else {
        const dataLogin = await handleLoginCredentials(email, password)
        if (dataLogin) {
          if (typeof DateTime !== 'undefined') {
            Settings.defaultLocale = locale
          }

          if (localeChanged) {
            await handleChangeLocale(dataLogin, locale)
          }

          setupNotifications(dataLogin)
          loginSuccessful(dataLogin)
        }
      }
    }
  }

  return useMutation({
    mutationFn: (credentials) => handleMutation(credentials),
    mutationKey: authMutationKeys.LOGIN,
    retry: false
  })
}
